import { TheNightlySection } from '@news-mono/common'
import { StaticRoutes } from '@news-mono/web-common'
import {
    isFeatureEnabled,
    toFeatureState,
} from '@west-australian-newspapers/etrigan-feature-toggles-client'
import { layout } from '../../App.routing'

const pageTitle = 'The Nightly App Download'
const description = 'Download the free The Nightly App Now!'

export const appDownload: StaticRoutes<TheNightlySection> = {
    '/app': ({ store, getAdTargeting }) => {
        const enableRoute = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'web-app-download-page',
        )

        if (!enableRoute) {
            return null
        }

        return {
            kind: 'page',
            heading: '',
            hideHeading: true,
            pageType: 'static',
            adTargeting: getAdTargeting('home', 'home', 'app'),
            pageMeta: {
                title: pageTitle,
                description,
            },
            section: 'default',
            additionalPageProperties: {
                fullPageWidth: true,
            },
            compositions: [
                layout.composition({
                    type: 'thor',
                    props: {
                        hasBackgroundFill: false,
                        containerWidth: '100%',
                        horizontalGutters: false,
                        verticalGutters: false,
                    },
                    contentAreas: {
                        main: [
                            layout.component({
                                type: 'tn-app-download-page',
                                props: {},
                            }),
                        ],
                    },
                }),
            ],
        }
    },
}
